import React, { FC } from 'react'

import InputItem from '../../../components/InputItem'
import { getFLAGCarbonValue } from './utils'
import { ITabBaseProps } from './types'

export const Emissions: FC<ITabBaseProps> = ({ isCustomEF, formik }) => {
  const flagNetCarbon = getFLAGCarbonValue(formik.values)

  return (
    <div className="piece-content-inputs mb-5">
      <InputItem
        disabled={isCustomEF.current}
        name="Original Net Carbon Emissions"
        description="Please provide carbon emissions in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        formikName="carbon"
        showAsterisk
        formik={formik}
        defaultValue={formik.values.carbon === 0 ? '0' : formik.values.carbon}
      />
      <InputItem
        disabled
        name="FLAG Net Carbon Emissions"
        description="FLAG carbon emissions in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        defaultValue={flagNetCarbon}
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Total Land Use Change Emissions"
        description="Please provide emissions in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        formikName="flag_L1_LandUseChangeCarbon"
        formik={formik}
        defaultValue={
          formik.values.flag_L1_LandUseChangeCarbon === 0
            ? '0'
            : formik.values.flag_L1_LandUseChangeCarbon
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Total Land Management, CO2 Emissions"
        description="Please provide carbon emissions in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        formikName="flag_L1_LandManagementCarbon"
        formik={formik}
        defaultValue={
          formik.values.flag_L1_LandManagementCarbon === 0
            ? '0'
            : formik.values.flag_L1_LandManagementCarbon
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Total Land Management, Non-CO2 Emissions"
        description="Please provide emissions in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        formikName="flag_L1_LandManagementNonCarbon"
        formik={formik}
        defaultValue={
          formik.values.flag_L1_LandManagementNonCarbon === 0
            ? '0'
            : formik.values.flag_L1_LandManagementNonCarbon
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Total Non-land Emissions"
        description="Please provide emissions in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        formikName="flag_L1_NonLandCarbon"
        formik={formik}
        defaultValue={
          formik.values.flag_L1_NonLandCarbon === 0 ? '0' : formik.values.flag_L1_NonLandCarbon
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Total Unverified Removals"
        description="Please provide emissions removed in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        formikName="flag_L1_UnverifiedRemovalsCarbon"
        showAsterisk
        formik={formik}
        defaultValue={
          formik.values.flag_L1_UnverifiedRemovalsCarbon === 0
            ? '0'
            : formik.values.flag_L1_UnverifiedRemovalsCarbon
        }
      />
      <InputItem
        disabled={isCustomEF.current}
        name="Total Verified Removals"
        description="Please provide emissions removed in g CO2 eq."
        type="input"
        addonTitle="g"
        onChange={formik.handleChange}
        formikName="flag_L1_VerifiedRemovalsCarbon"
        showAsterisk
        formik={formik}
        defaultValue={
          formik.values.flag_L1_VerifiedRemovalsCarbon === 0
            ? '0'
            : formik.values.flag_L1_VerifiedRemovalsCarbon
        }
      />
      <h6 className="mt-3">Detailed GHG</h6>
      <div className="piece-content-inputs">
        <InputItem
          name="GHG total - EF 3.1 / PEF (emissions minus removals)"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue(
              'impacts.ghgTotal_EF_PEF_EmissionsMinusRemovals',
              val === '' ? null : val
            )
          }}
          formikName="impacts.ghgTotal_EF_PEF_EmissionsMinusRemovals"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.ghgTotal_EF_PEF_EmissionsMinusRemovals === 0
              ? '0'
              : formik.values.impacts.ghgTotal_EF_PEF_EmissionsMinusRemovals
          }
        />
        <InputItem
          name="Stationary combustion"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.stationaryCombustion', val === '' ? null : val)
          }}
          formikName="impacts.stationaryCombustion"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.stationaryCombustion === 0
              ? '0'
              : formik.values.impacts.stationaryCombustion
          }
        />
        <InputItem
          name="Mobile combustion"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.mobileCombustion', val === '' ? null : val)
          }}
          formikName="impacts.mobileCombustion"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.mobileCombustion === 0
              ? '0'
              : formik.values.impacts.mobileCombustion
          }
        />
        <InputItem
          name="Process emissions"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.processEmissions', val === '' ? null : val)
          }}
          formikName="impacts.processEmissions"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.processEmissions === 0
              ? '0'
              : formik.values.impacts.processEmissions
          }
        />
        <InputItem
          name="Fugitive emissions"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.fugitiveEmissions', val === '' ? null : val)
          }}
          formikName="impacts.fugitiveEmissions"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.fugitiveEmissions === 0
              ? '0'
              : formik.values.impacts.fugitiveEmissions
          }
        />
        <InputItem
          name="Land emissions"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.landEmissions', val === '' ? null : val)
          }}
          formikName="impacts.landEmissions"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.landEmissions === 0 ? '0' : formik.values.impacts.landEmissions
          }
        />
        <InputItem
          name="Land management net biogenic CO2 emissions"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue(
              'impacts.landManagementNetBiogenicCO2Emissions',
              val === '' ? null : val
            )
          }}
          formikName="impacts.landManagementNetBiogenicCO2Emissions"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.landManagementNetBiogenicCO2Emissions === 0
              ? '0'
              : formik.values.impacts.landManagementNetBiogenicCO2Emissions
          }
        />
        <InputItem
          name="Land management production emissions"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue(
              'impacts.landManagementProductionEmissions',
              val === '' ? null : val
            )
          }}
          formikName="impacts.landManagementProductionEmissions"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.landManagementProductionEmissions === 0
              ? '0'
              : formik.values.impacts.landManagementProductionEmissions
          }
        />
        <InputItem
          name="Biogenic product emissions"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.biogenicProductEmissions', val === '' ? null : val)
          }}
          formikName="impacts.biogenicProductEmissions"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.biogenicProductEmissions === 0
              ? '0'
              : formik.values.impacts.biogenicProductEmissions
          }
        />
        <InputItem
          name="Inputs production"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.inputsProduction', val === '' ? null : val)
          }}
          formikName="impacts.inputsProduction"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.inputsProduction === 0
              ? '0'
              : formik.values.impacts.inputsProduction
          }
        />
        <InputItem
          name="Carbon Dioxide"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.carbonDioxide', val === '' ? null : val)
          }}
          formikName="impacts.carbonDioxide"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.carbonDioxide === 0 ? '0' : formik.values.impacts.carbonDioxide
          }
        />
        <InputItem
          name="Fossil Carbon Dioxide"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.fossilCarbonDioxide', val === '' ? null : val)
          }}
          formikName="impacts.fossilCarbonDioxide"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.fossilCarbonDioxide === 0
              ? '0'
              : formik.values.impacts.fossilCarbonDioxide
          }
        />
        <InputItem
          name="Biogenic Carbon Dioxide"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.biogenicCarbonDioxide', val === '' ? null : val)
          }}
          formikName="impacts.biogenicCarbonDioxide"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.biogenicCarbonDioxide === 0
              ? '0'
              : formik.values.impacts.biogenicCarbonDioxide
          }
        />
        <InputItem
          name="Methane"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.methane', val === '' ? null : val)
          }}
          formikName="impacts.methane"
          formik={formik}
          showAsterisk={false}
          defaultValue={formik.values.impacts.methane === 0 ? '0' : formik.values.impacts.methane}
        />
        <InputItem
          name="Fossil Methane"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.fossilMethane', val === '' ? null : val)
          }}
          formikName="impacts.fossilMethane"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.fossilMethane === 0 ? '0' : formik.values.impacts.fossilMethane
          }
        />
        <InputItem
          name="Biogenic Methane"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.biogenicMethane', val === '' ? null : val)
          }}
          formikName="impacts.biogenicMethane"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.biogenicMethane === 0
              ? '0'
              : formik.values.impacts.biogenicMethane
          }
        />
        <InputItem
          name="Nitrous Oxide"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.nitrousOxide', val === '' ? null : val)
          }}
          formikName="impacts.nitrousOxide"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.nitrousOxide === 0 ? '0' : formik.values.impacts.nitrousOxide
          }
        />
        <InputItem
          name="Fluorinated GHGs"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.fluorinatedGHGs', val === '' ? null : val)
          }}
          formikName="impacts.fluorinatedGHGs"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.fluorinatedGHGs === 0
              ? '0'
              : formik.values.impacts.fluorinatedGHGs
          }
        />
        <InputItem
          name="HFCs"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.hfCs', val === '' ? null : val)
          }}
          formikName="impacts.hfCs"
          formik={formik}
          showAsterisk={false}
          defaultValue={formik.values.impacts.hfCs === 0 ? '0' : formik.values.impacts.hfCs}
        />
        <InputItem
          name="PFCs"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.pfCs', val === '' ? null : val)
          }}
          formikName="impacts.pfCs"
          formik={formik}
          showAsterisk={false}
          defaultValue={formik.values.impacts.pfCs === 0 ? '0' : formik.values.impacts.pfCs}
        />
        <InputItem
          name="SF6"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.sF6', val === '' ? null : val)
          }}
          formikName="impacts.sF6"
          formik={formik}
          showAsterisk={false}
          defaultValue={formik.values.impacts.sF6 === 0 ? '0' : formik.values.impacts.sF6}
        />
        <InputItem
          name="NF3"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.nF3', val === '' ? null : val)
          }}
          formikName="impacts.nF3"
          formik={formik}
          showAsterisk={false}
          defaultValue={formik.values.impacts.nF3 === 0 ? '0' : formik.values.impacts.nF3}
        />
        <InputItem
          name="Scope 1"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope1', val === '' ? null : val)
          }}
          formikName="impacts.scope1"
          formik={formik}
          showAsterisk={false}
          defaultValue={formik.values.impacts.scope1 === 0 ? '0' : formik.values.impacts.scope1}
        />
        <InputItem
          name="Scope 1 - CO2"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope1_CO2', val === '' ? null : val)
          }}
          formikName="impacts.scope1_CO2"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope1_CO2 === 0 ? '0' : formik.values.impacts.scope1_CO2
          }
        />
        <InputItem
          name="Scope 1 - CH4"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope1_CH4', val === '' ? null : val)
          }}
          formikName="impacts.scope1_CH4"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope1_CH4 === 0 ? '0' : formik.values.impacts.scope1_CH4
          }
        />
        <InputItem
          name="Scope 1 - N2O"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope1_N2O', val === '' ? null : val)
          }}
          formikName="impacts.scope1_N2O"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope1_N2O === 0 ? '0' : formik.values.impacts.scope1_N2O
          }
        />
        <InputItem
          name="Scope 1 - HFCs"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope1_HFCs', val === '' ? null : val)
          }}
          formikName="impacts.scope1_HFCs"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope1_HFCs === 0 ? '0' : formik.values.impacts.scope1_HFCs
          }
        />
        <InputItem
          name="Scope 1 - PFCs"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope1_PFCs', val === '' ? null : val)
          }}
          formikName="impacts.scope1_PFCs"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope1_PFCs === 0 ? '0' : formik.values.impacts.scope1_PFCs
          }
        />
        <InputItem
          name="Scope 1 - SF6"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope1_SF6', val === '' ? null : val)
          }}
          formikName="impacts.scope1_SF6"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope1_SF6 === 0 ? '0' : formik.values.impacts.scope1_SF6
          }
        />
        <InputItem
          name="Scope 1 - NF3"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope1_NF3', val === '' ? null : val)
          }}
          formikName="impacts.scope1_NF3"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope1_NF3 === 0 ? '0' : formik.values.impacts.scope1_NF3
          }
        />
        <InputItem
          name="Scope 2"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope2', val === '' ? null : val)
          }}
          formikName="impacts.scope2"
          formik={formik}
          showAsterisk={false}
          defaultValue={formik.values.impacts.scope2 === 0 ? '0' : formik.values.impacts.scope2}
        />
        <InputItem
          name="Scope 2 - CO2"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope2_CO2', val === '' ? null : val)
          }}
          formikName="impacts.scope2_CO2"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope2_CO2 === 0 ? '0' : formik.values.impacts.scope2_CO2
          }
        />
        <InputItem
          name="Scope 2 - CH4"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope2_CH4', val === '' ? null : val)
          }}
          formikName="impacts.scope2_CH4"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope2_CH4 === 0 ? '0' : formik.values.impacts.scope2_CH4
          }
        />
        <InputItem
          name="Scope 2 - N2O"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope2_N2O', val === '' ? null : val)
          }}
          formikName="impacts.scope2_N2O"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope2_N2O === 0 ? '0' : formik.values.impacts.scope2_N2O
          }
        />
        <InputItem
          name="Scope 2 - HFCs"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope2_HFCs', val === '' ? null : val)
          }}
          formikName="impacts.scope2_HFCs"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope2_HFCs === 0 ? '0' : formik.values.impacts.scope2_HFCs
          }
        />
        <InputItem
          name="Scope 2 - PFCs"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope2_PFCs', val === '' ? null : val)
          }}
          formikName="impacts.scope2_PFCs"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope2_PFCs === 0 ? '0' : formik.values.impacts.scope2_PFCs
          }
        />
        <InputItem
          name="Scope 2 - SF6"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope2_SF6', val === '' ? null : val)
          }}
          formikName="impacts.scope2_SF6"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope2_SF6 === 0 ? '0' : formik.values.impacts.scope2_SF6
          }
        />
        <InputItem
          name="Scope 2 - NF3"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope2_NF3', val === '' ? null : val)
          }}
          formikName="impacts.scope2_NF3"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope2_NF3 === 0 ? '0' : formik.values.impacts.scope2_NF3
          }
        />
        <InputItem
          name="Scope 3"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope3', val === '' ? null : val)
          }}
          formikName="impacts.scope3"
          formik={formik}
          showAsterisk={false}
          defaultValue={formik.values.impacts.scope3 === 0 ? '0' : formik.values.impacts.scope3}
        />
        <InputItem
          name="Scope 3 - CO2"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope3_CO2', val === '' ? null : val)
          }}
          formikName="impacts.scope3_CO2"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope3_CO2 === 0 ? '0' : formik.values.impacts.scope3_CO2
          }
        />
        <InputItem
          name="Scope 3 - CH4"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope3_CH4', val === '' ? null : val)
          }}
          formikName="impacts.scope3_CH4"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope3_CH4 === 0 ? '0' : formik.values.impacts.scope3_CH4
          }
        />
        <InputItem
          name="Scope 3 - N2O"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope3_N2O', val === '' ? null : val)
          }}
          formikName="impacts.scope3_N2O"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope3_N2O === 0 ? '0' : formik.values.impacts.scope3_N2O
          }
        />
        <InputItem
          name="Scope 3 - HFCs"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope3_HFCs', val === '' ? null : val)
          }}
          formikName="impacts.scope3_HFCs"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope3_HFCs === 0 ? '0' : formik.values.impacts.scope3_HFCs
          }
        />
        <InputItem
          name="Scope 3 - PFCs"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope3_PFCs', val === '' ? null : val)
          }}
          formikName="impacts.scope3_PFCs"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope3_PFCs === 0 ? '0' : formik.values.impacts.scope3_PFCs
          }
        />
        <InputItem
          name="Scope 3 - SF6"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope3_SF6', val === '' ? null : val)
          }}
          formikName="impacts.scope3_SF6"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope3_SF6 === 0 ? '0' : formik.values.impacts.scope3_SF6
          }
        />
        <InputItem
          name="Scope 3 - NF3"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.scope3_NF3', val === '' ? null : val)
          }}
          formikName="impacts.scope3_NF3"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope3_NF3 === 0 ? '0' : formik.values.impacts.scope3_NF3
          }
        />
        <InputItem
          name="Scope 3 cat 1 - Purchased goods & services"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue(
              'impacts.scope3Cat1_PurchasedGoodsServices',
              val === '' ? null : val
            )
          }}
          formikName="impacts.scope3Cat1_PurchasedGoodsServices"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope3Cat1_PurchasedGoodsServices === 0
              ? '0'
              : formik.values.impacts.scope3Cat1_PurchasedGoodsServices
          }
        />
        <InputItem
          name="Scope 3 cat 3 - Fuel & energy related activities"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue(
              'impacts.scope3Cat3_FuelEnergyRelatedActivities',
              val === '' ? null : val
            )
          }}
          formikName="impacts.scope3Cat3_FuelEnergyRelatedActivities"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.scope3Cat3_FuelEnergyRelatedActivities === 0
              ? '0'
              : formik.values.impacts.scope3Cat3_FuelEnergyRelatedActivities
          }
        />
        <InputItem
          name="Land management CO2 removals"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.landManagementCO2Removals', val === '' ? null : val)
          }}
          formikName="impacts.landManagementCO2Removals"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.landManagementCO2Removals === 0
              ? '0'
              : formik.values.impacts.landManagementCO2Removals
          }
        />
        <InputItem
          name="Captured biogenic CO2 with geologic storage"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue(
              'impacts.capturedBiogenicCO2WithGeologicStorage',
              val === '' ? null : val
            )
          }}
          formikName="impacts.capturedBiogenicCO2WithGeologicStorage"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.capturedBiogenicCO2WithGeologicStorage === 0
              ? '0'
              : formik.values.impacts.capturedBiogenicCO2WithGeologicStorage
          }
        />
        <InputItem
          name="Technological CO2 removals with geologic storage"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue(
              'impacts.technologicalCO2RemovalsWithGeologicStorage',
              val === '' ? null : val
            )
          }}
          formikName="impacts.technologicalCO2RemovalsWithGeologicStorage"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.technologicalCO2RemovalsWithGeologicStorage === 0
              ? '0'
              : formik.values.impacts.technologicalCO2RemovalsWithGeologicStorage
          }
        />
        <InputItem
          name="Outside LSRS"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.outsideLSRS', val === '' ? null : val)
          }}
          formikName="impacts.outsideLSRS"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.outsideLSRS === 0 ? '0' : formik.values.impacts.outsideLSRS
          }
        />
        <InputItem
          name="Montreal Protocol substance (industrial processes)"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue(
              'impacts.montrealProtocolSubstance_IndustrialProcesses',
              val === '' ? null : val
            )
          }}
          formikName="impacts.montrealProtocolSubstance_IndustrialProcesses"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.montrealProtocolSubstance_IndustrialProcesses === 0
              ? '0'
              : formik.values.impacts.montrealProtocolSubstance_IndustrialProcesses
          }
        />
        <InputItem
          name="Montreal Protocol substance (inputs production)"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue(
              'impacts.montrealProtocolSubstance_InputsProduction',
              val === '' ? null : val
            )
          }}
          formikName="impacts.montrealProtocolSubstance_InputsProduction"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.montrealProtocolSubstance_InputsProduction === 0
              ? '0'
              : formik.values.impacts.montrealProtocolSubstance_InputsProduction
          }
        />
        <InputItem
          name="Other fluorinated GHG (industrial processes)"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue(
              'impacts.otherFluorinatedGHG_IndustrialProcesses',
              val === '' ? null : val
            )
          }}
          formikName="impacts.otherFluorinatedGHG_IndustrialProcesses"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.otherFluorinatedGHG_IndustrialProcesses === 0
              ? '0'
              : formik.values.impacts.otherFluorinatedGHG_IndustrialProcesses
          }
        />
        <InputItem
          name="Other fluorinated GHG (inputs production)"
          description="Unit of Measure: kg CO2eq"
          type="input"
          addonTitle="kg CO2eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue(
              'impacts.otherFluorinatedGHG_InputsProduction',
              val === '' ? null : val
            )
          }}
          formikName="impacts.otherFluorinatedGHG_InputsProduction"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.otherFluorinatedGHG_InputsProduction === 0
              ? '0'
              : formik.values.impacts.otherFluorinatedGHG_InputsProduction
          }
        />
      </div>
    </div>
  )
}

export default Emissions
